import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import cycleBg from "../Img/cycle1.png";
import person1 from "../Img/person1.jpg";
import person2 from "../Img/person2.jpg";
import person3 from "../Img/person3.jpg";
import person4 from "../Img/person4.jpg";
import cycleDetailImage from "../Img/cycle-detail-image.png";
import contactFormBg from "../Img/contact-form-bg.png";
import tribeimage from "../Img/gallery.png";
import gearCycle from "../Img/cycle/gear.png";
import kidsCycle from "../Img/cycle/kids.png";
import nonGearCycle from "../Img/cycle/nongear.png";
import premiumCycle from "../Img/cycle/premium.png";
import {
  Bike, Package, Wind, RefreshCw, Bell, Shield, Video, Wrench, 
  Repeat, PhoneCall, Star, ChevronLeft, ChevronRight, Phone, 
  Mail, User, Smartphone, MessageCircle,
} from "lucide-react";
import "../CSS/Global.css";
import "../CSS/Home.css";
import { sendToWhatsApp } from "./utils/Whatsapp";
import { Link } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const [startIndex, setStartIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  // Data arrays
  const includes = [
    { icon: <Bell className="include-icon" />, title: "Fully Equipped Cycle", description: "Receive a well-maintained bicycle equipped with essentials like a bell, adjustable seat, bottle holder, mudguards, and seat cover for a smooth and comfortable ride." },
    { icon: <Shield className="include-icon" />, title: "Safety Gear", description: "Every rental comes with a safety kit including a helmet, lock, reflectors, and tail light to ensure you stay safe while enjoying your ride." },
    { icon: <Video className="include-icon" />, title: "Helpful Video Guides", description: "Access easy tutorial videos whenever you need help. Learn basics like gear shifting, fixing the chain, and maintaining proper tyre pressure." },
    { icon: <Wrench className="include-icon" />, title: "3 Complimentary Services", description: "Enjoy up to three free servicing sessions during your rental period to keep your bicycle in excellent condition without any extra cost." },
    { icon: <Repeat className="include-icon" />, title: "Flexible Cycle Exchange", description: "Switch your bicycle anytime. Upgrade or change between non-gear, geared, or premium cycles depending on your riding preference." },
    { icon: <PhoneCall className="include-icon" />, title: "24/7 Customer Support", description: "Our support team is available day and night to assist you with any issues, ensuring your cycling experience remains smooth and worry-free." },
  ];

  const pricingPlans = [
    { title: "NON GEAR", price: "599", gradient: "linear-gradient(135deg, #64748B, #475569)", popular: false },
    { title: "GEAR", price: "899", gradient: "linear-gradient(135deg, #1997D4, #0EA5E9)", popular: true },
    { title: "PREMIUM", price: "1,499", gradient: "linear-gradient(135deg, #F59E0B, #FBBF24)", popular: false },
    { title: "KIDS", price: "249", gradient: "linear-gradient(135deg, #EC4899, #F472B6)", popular: false },
  ];

  const testimonials = [
    { name: "Vishal Desai", rating: 5, text: "I rented a bicycle from Cycle Rental Service last month and it was in excellent condition. The whole rental process was quick and very simple. Riding the cycle was a great experience and I will definitely rent again in the future. I highly recommend Cycle Rental Service to anyone looking for a reliable cycle rental.", image: person1 },
    { name: "Shraddha Aryaa", rating: 5, text: "Renting a cycle from Cycle Rental Service was a wonderful experience for me. After my second baby, I wanted to get back into a healthy routine and cycling helped a lot. The bicycles were comfortable and the team was extremely supportive. I truly appreciate their service and wish them continued success.", image: person2 },
    { name: "Alisha Pereira", rating: 5, text: "My experience with Cycle Rental Service was very smooth from the first enquiry to the delivery and pickup of the bicycle. I wanted to relearn cycling after many years and their team was very helpful. They even suggested the right cycle based on my height, which made the ride comfortable and enjoyable.", image: person3 },
    { name: "Binnita Shah", rating: 5, text: "I was searching online to rent cycles for myself and my brother when I found Cycle Rental Service. The team was very friendly and helped us even on short notice during a Sunday. They took the time to understand our plans and recommended the best cycles for us. It was a great experience overall.", image: person4 },
  ];

  const steps = [
    { icon: Bike, title: "Choose Your Cycle", description: "Browse and pick the perfect bicycle from our wide range of options" },
    { icon: Package, title: "Doorstep Delivery", description: "Your selected bicycle and safety gear will be delivered to your location" },
    { icon: Wind, title: "Enjoy Your Ride", description: "Ride with confidence knowing support and service are always available" },
    { icon: RefreshCw, title: "Extend or Return", description: "Renew your rental, switch cycles, or return it whenever you're ready" },
  ];

  const cycleTypesBase = [
    { name: "KIDS", image: kidsCycle },
    { name: "PREMIUM", image: premiumCycle },
    { name: "GEAR", image: gearCycle },
    { name: "NON GEAR", image: nonGearCycle },
  ];
  
  // CRITICAL: Duplicate MANY times for seamless infinite scroll
  // The more duplicates, the smoother the infinite loop
  const cycleTypes = [...cycleTypesBase, ...cycleTypesBase, ...cycleTypesBase, ...cycleTypesBase, ...cycleTypesBase, ...cycleTypesBase];

  const contactInfo = [
    { icon: Phone, text: "+91 1234567891", href: "tel:+911234567891" },
    { icon: Mail, text: "cyclerental@gmail.com", href: "mailto:cyclerental@gmail.com" },
  ];

  const formFields = [
    { icon: User, type: "text", placeholder: "Full Name", name: "name", required: true },
    { icon: Smartphone, type: "tel", placeholder: "Mobile Number", name: "phone", required: true },
    { icon: Mail, type: "email", placeholder: "Email", name: "email", required: true },
    { icon: MessageCircle, type: "text", placeholder: "What are you looking for?", name: "inquiry", required: false },
  ];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star key={index} size={16} className={index < rating ? "star-filled" : "star-empty"} fill={index < rating ? "currentColor" : "none"} />
    ));
  };

  const nextSlide = () => {
    if (startIndex + 3 < testimonials.length) setStartIndex(startIndex + 1);
  };

  const prevSlide = () => {
    if (startIndex > 0) setStartIndex(startIndex - 1);
  };

  const [formData, setFormData] = useState({ name: '', phone: '', email: '', inquiry: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New request Form Submission from Home page:\n\n*Name:* ${formData.name}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Inquiry:* ${formData.inquiry}`;
    sendToWhatsApp(message);
    setFormData({ name: '', phone: '', email: '', inquiry: '' });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Infinite scroll animation
  useEffect(() => {
    const track = trackRef.current;
    const container = containerRef.current;
    
    if (!track || !container) return;

    const isDesktop = window.innerWidth > 768;
    if (!isDesktop) return;

    let position = 0;
    const speed = 0.5;
    
    // Get width of one set of items
    const getOneSetWidth = () => {
      const items = track.children;
      if (items.length === 0) return 800;
      
      let width = 0;
      const gap = 32;
      
      for (let i = 0; i < cycleTypesBase.length && i < items.length; i++) {
        width += items[i].offsetWidth + gap;
      }
      return width;
    };
    
    const scroll = () => {
      if (isPaused) {
        animationRef.current = requestAnimationFrame(scroll);
        return;
      }
      
      position -= speed;
      const oneSetWidth = getOneSetWidth();
      
      // Reset position when we've scrolled past one set
      if (Math.abs(position) >= oneSetWidth) {
        position = 0;
      }
      
      track.style.transform = `translateX(${position}px)`;
      animationRef.current = requestAnimationFrame(scroll);
    };
    
    animationRef.current = requestAnimationFrame(scroll);
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPaused, cycleTypesBase.length]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <div className="min-h-screen">
      {/* 1. Rental Hero Section */}
      {/* 1. Rental Hero Section */}
<section className="rental-hero-section">
  <div className="rental-hero-bg-spot spot-1"></div>
  <div className="rental-hero-bg-spot spot-2"></div>
  <div className="container">
    <div className="rental-hero-content">
      <h1 className="rental-hero-title">Your Reliable Bicycle Rental Companion</h1>
      <p className="rental-hero-subtitle">Rent affordable and well-maintained bicycles easily</p>
      <Link to="/products" className="rental-hero-btn">Book Your Cycle →</Link>
    </div>

    {/* Infinite Scroll Container */}
    <div 
      className="rental-cycle-container"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="rental-cycle-track" ref={trackRef}>
        {cycleTypes.map((cycle, index) => (
          <div key={index} className="rental-cycle-item">
            <img src={cycle.image} alt={cycle.name} />
            <span>{cycle.name}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

      {/* 2. Hero Followup Section */}
      <section className="hero-followup-section">
        <div className="container">
          <div className="followup-content">
            <div className="followup-left">
              <h2 className="followup-title">Select Your Perfect Ride</h2>
              <p className="followup-subtitle">High-quality bicycles brought straight to you</p>
              <Link to="/products" className="followup-cta">Ride Today →</Link>
            </div>
            <div className="followup-right">
              <img src={cycleDetailImage} alt="Premium Cycle Detail" className="followup-image" />
            </div>
          </div>
        </div>
      </section>

      {/* 3. How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How it Works</h2>
          <div className="steps">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <div key={index} className="step">
                  <IconComponent className="step-icon" />
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 4. CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title-two-same">Ready to Start Your Ride?</h2>
          <p className="cta-subtitle">Choose from 350+ premium cycles. Home delivery in 24 hours.</p>
          <Link to="/products" className="cta-button">Rent a Cycle Now →</Link>
        </div>
      </section>

      {/* 5. Includes Section */}
      <section className="includes-section">
        <div className="container">
          <h2 className="section-title">What's Included</h2>
          <div className="includes-grid">
            {includes.map((item, index) => (
              <div className="include-card" key={index}>
                <div className="include-icon-wrapper">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. Pricing Section */}
      <section className="pricing-section-simple">
        <div className="container">
          <h2 className="section-title">Choose Your Rental Plan</h2>
          <p className="section-subtitle">Choose the perfect plan for your riding needs</p>
          <div className="pricing-grid-simple">
            {pricingPlans.map((plan, index) => (
              <div key={index} className={`pricing-card-simple ${plan.popular ? "popular" : ""}`}>
                {plan.popular && (
                  <div className="popular-badge-simple">
                    <Star size={14} />
                    <span>Most Popular</span>
                  </div>
                )}
                <h3>{plan.title}</h3>
                <div className="price-container-simple">
                  <span className="currency">Rs</span>
                  <span className="price">{plan.price}</span>
                  <span className="period">/month*</span>
                </div>
                <button className="choose-plan-btn-simple" style={{ background: plan.gradient }} onClick={() => navigate('/products')}>
                  Choose
                </button>
                <p className="pricing-note-simple">*Prices mentioned above are for the yearly cycle rental</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7. Second CTA Section */}
      <section className="cta-section-two-same">
        <div className="container">
          <h2 className="section-title-two-same">Don't ignore your fitness, start cycling today</h2>
          <p className="cta-subtitle-two-same">Rent a bicycle and take the first step toward a healthier lifestyle</p>
          <Link to="/products" className="cta-button-two-same">Start Riding →</Link>
        </div>
      </section>

      {/* 8. Testimonials Section */}
      <section className="testimonials-carousel-section">
        <div className="container">
          <h2 className="section-title">What Our Riders Say</h2>
          <div className="testimonials-carousel-container">
            <button className={`carousel-arrow carousel-arrow-left ${startIndex === 0 ? "disabled" : ""}`} onClick={prevSlide} disabled={startIndex === 0}>
              <ChevronLeft size={24} />
            </button>
            <div className="testimonials-carousel-track">
              {testimonials.slice(startIndex, startIndex + 3).map((testimonial, index) => (
                <div key={startIndex + index} className="testimonial-carousel-card">
                  <div className="testimonial-header">
                    <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
                    <div className="testimonial-info">
                      <h4>{testimonial.name}</h4>
                      <div className="testimonial-rating">{renderStars(testimonial.rating)}</div>
                    </div>
                  </div>
                  <div className="testimonial-content">
                    <p>"{testimonial.text}"</p>
                  </div>
                </div>
              ))}
            </div>
            <button className={`carousel-arrow carousel-arrow-right ${startIndex + 3 >= testimonials.length ? "disabled" : ""}`} onClick={nextSlide} disabled={startIndex + 3 >= testimonials.length}>
              <ChevronRight size={24} />
            </button>
          </div>
          <div className="carousel-dots">
            {Array.from({ length: Math.ceil(testimonials.length - 2) }).map((_, index) => (
              <button key={index} className={`carousel-dot ${index === startIndex ? "active" : ""}`} onClick={() => setStartIndex(index)} />
            ))}
          </div>
        </div>
      </section>

      {/* 9. Join Tribe Section */}
      <section className="join-tribe-section">
        <div className="container">
          <div className="join-tribe-content">
            <h2 className="tribe-section-title">Join Our Community</h2>
            <img src={tribeimage} alt="Join the Tribe Gallery" className="join-tribe-image" />
          </div>
        </div>
      </section>

      {/* 10. Contact Section */}
      <section className="home-section">
        <div className="home-overlay"></div>
        <div className="container">
          <div className="home-content">
            <h2 className="home-title">Here To Support You</h2>
            <div className="home-contact">
              {contactInfo.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="home-contact-item">
                    <IconComponent size={20} />
                    <a href={item.href}>{item.text}</a>
                  </div>
                );
              })}
            </div>
            <form className="home-form" onSubmit={handleSubmit}>
              {formFields.map((field, index) => {
                const IconComponent = field.icon;
                return (
                  <div key={index} className="form-group">
                    <IconComponent size={18} className="form-icon" />
                    <input
                      type={field.type}
                      name={field.name}
                      placeholder={field.placeholder}
                      value={formData[field.name]}
                      required={field.required}
                      onChange={handleInputChange}
                    />
                  </div>
                );
              })}
              <button type="submit" className="home-submit-btn">Submit</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;